<!--
 * @Author: jian.li jian.li@genetronhealth.com
 * @Date: 2022-11-17 16:26:20
 * @LastEditors: jian.li jian.li@genetronhealth.com
 * @LastEditTime: 2022-11-17 17:50:21
 * @FilePath: \FSZ-GALILEO-WEB\genetron-web\genetron-h5\src\views\reportQuery\answerQuestion.vue
 * @Description: 
-->
<template>
  <div id="answerQuestionBox">
    <div class="title">Q1 为什么登录后找不到创建订单按钮？</div>
    <div class="test">
      APP登录时，使用用户名、密码登录才可创建订单；登录用户名为（个人的公司邮箱名字），密码同邮箱密码。不可使用手机号码登录，如果使用手机号码登录，无法创建订单。
    </div>
    <div class="title">Q2 订单收款时，不能修改产品应付金额怎么办？</div>
    <div class="test">
      收款的产品应付金额等于实收价格（合同价格），订单在选择检测项目后，直接修改实收价格（合同价格），对应的产品应付金额同步修改。
    </div>
    <div class="title">
      Q3 电子合同已签署后，发现检测产品价格不对，想修改价格怎么办？
    </div>
    <div class="test">
      电子合同已签署代表合同已生效，不可修改原合同，可以签署电子补充协议，更改价格。订单正常提交后审批通过，点击【申请修改】，进行订单修改流程点击【修改产品】，更改产品实收价格（合同价格）后，在收款信息补差价后提交订单；如果需要退款，提交退款申请即可。
    </div>
    <div class="title">Q4 为什么新建的取样单提交后，没有和订单自动挂连？</div>
    <div class="test">
      订单审批通过后，才可和取样单挂连成功。如果先创建的取样单提交，没有订单信息，系统会自动生成临时订单，待填写订单信息后，临时订单会转变成普通订单，订单提交并审批通过后，点击取样单【修改】，关联订单的产品后再次提交，可自动与订单挂连成功。
    </div>
    <div class="title">Q5 为什么找不到申请退款的按钮？</div>
    <div class="test">
      只有财务对账后，才会显示申请退款的按钮，先和财务确认订单款财务是否对账。
    </div>
    <div class="title">
      Q6 患者/委托人想使用订单的微信小程序查看电子合同和报告，怎么在小程序登录？
    </div>
    <div class="test">
      三个途径可以找到小程序入口：<br />
      1，微信小程序直接搜索；具体方法：打开微信搜索小程序，输入“泛生子BRAVE”，在搜出的结果中，点击“泛生子BRAVE”。<br />
      2，通过微信公众号“泛生子基因”进入小程序；具体方法：关注微信“泛生子基因”公众号后，打开公众号，右下角点击“走进我们”——报告查询。<br />
      3，通过微信公众号“泛生子在线”进入小程序；具体方法：关注微信“泛生子在线”公众号后，打开公众号，右下角点击‘服务中心’——报告查询。<br />
      三种方式进入微信小程序后，登录页选择手机号登录，使用签署合同人填写的手机号码和验证码，登录小程序。小程序“我的”中看到检测单，可查询合同和报告。<br />
    </div>
    <div class="title">
      Q7 签署电子合同时，用户觉得人脸识别不安全，是否有其他方式实名认证？
    </div>
    <div class="test">
      有，认证方式默认是人脸认证，点击最右边的箭头，可切换为手机验证码认证，输入手机验证码也可实名认证。
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  methods: {},
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
#answerQuestionBox {
  padding: 24px;
  .title {
    font-size: 15px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #2f354d;
    line-height: 24px;
    margin-bottom: 10px;
  }
  .test {
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #5f697d;
    line-height: 24px;
    margin-bottom: 40px;
  }
}
</style>
